import {Typography} from '@mui/material';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {renderAsyncView} from 'Shared/components/RenderAsync';
import {A360CommissionSection} from '../CommissionSection';
import {A360CommissionsSectionError, A360CommissionsSectionNoRecordsFound, LoadingSpinner} from '../Placeholders';
import {CommissionSummary} from '../types';
import {getCommissionSummary} from 'Agent/Commissions/ducks/a360Commissions';
import {isAsyncServerError} from 'Core/models/Async';
import {formatCurrency} from 'Shared/utilities/FormatMoney';

const CommissionSummaryGroupTable = ({
  summaryTitle,
  summaryGroup,
}: {
  summaryGroup: CommissionSummary;
  summaryTitle: string;
}) => {
  return (
    <div className="a360-commissions__table-layout">
      {Array.isArray(summaryGroup) && (
        <table>
          <thead>
            <tr>
              <th scope="col" colSpan={2}>
                <Typography
                  component="h3"
                  sx={{fontWeight: 700}}
                  className="a360-commissions__commission-summary-headers"
                >
                  {summaryTitle}
                </Typography>
              </th>
            </tr>
          </thead>
          <tbody>
            {summaryGroup.map(item => (
              <tr key={item.sequence}>
                <td style={{fontWeight: 600}}>{item.reportingItemName}</td>
                <td>{formatCurrency(item.totalAmount)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export const CommissionSummaryView = () => {
  const {commissionSummary} = useSelector((state: ReducerState) => state.a360Commissions);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCommissionSummary());
  }, []);

  return (
    <A360CommissionSection
      title="Commission Summary"
      className="a360-commissions__commission-summary"
      aria-label="commission summary"
    >
      {isAsyncServerError(commissionSummary) ? (
        <A360CommissionsSectionError error={commissionSummary.errorDetails} />
      ) : (
        renderAsyncView(
          commissionSummary,
          commissionSummaryData => (
            <>
              {commissionSummaryData && Object.keys(commissionSummaryData).length > 0 ? (
                <div className="a360-commissions__commission-summary_group">
                  {Object.keys(commissionSummaryData).map(summaryGroup => (
                    <CommissionSummaryGroupTable
                      summaryTitle={summaryGroup}
                      summaryGroup={commissionSummaryData[summaryGroup]}
                      key={summaryGroup}
                    />
                  ))}
                </div>
              ) : (
                <A360CommissionsSectionNoRecordsFound />
              )}
            </>
          ),
          LoadingSpinner
        )
      )}
    </A360CommissionSection>
  );
};
